import { Component, OnDestroy, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GuestService } from '../../shared/services/guest.service';
import { PopupService } from '../../shared/services/popup.service';
import { BookingActivity, ClassType, LessonTypes } from '../../shared/Models/SessionBookingDTO';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { urlConfig } from '../../shared/constants/url-config';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { ValidationMessageType } from 'src/app/shared/Models/ResultModels';
import { ActivityBookings, ActivityViewType, ControlSettings, LocationFilter, PropertyType } from 'src/app/shared/constants/commonenums';
import moment from 'moment';
import { ReservationService } from 'src/app/layout/reservation.service';
import _ from 'lodash';
import { ActivitiesDataDic } from '../activities-lite.data';
import { ActivityListFilterPipe } from 'src/app/shared/pipes/activity-list-filter.pipe';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-activities-list',
  templateUrl: './activities-list.component.html',
  styleUrls: ['./activities-list.component.scss', './../activities-lite.component.scss']
})

export class ActivitiesListComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  isDataLoaded = false;
  outOfServiceMessage: any;
  availableActivities = [];
  tempAvailableActivities = [];
  venueList = [];
  originalVenueList = [];
  diningVenuesList = [];
  displayByType = 'non_dining';
  venueBasedActivityList = [];
  filterByVenue = false;
  selectedVenueName = '';
  selectedActivities: any;
  textMaxLegth = 500;
  descriptionReadMoreClicked = false;
  safetyInformationReadMoreClicked = false;
  cancellationPolicyReadMoreCilcked = false;
  showAvailableSlotCount = true;
  toggleView = 1;
  filteredVenue = 'allActivities';
  noDataFound = false;
  widgetConfigurations: any = {};
  dateFilterStartDate: Date;
  dateFilterEndDate: Date;
  dayLightDelta = '-4';
  currentDateTime: Date;
  loadActivitiesOnly = false;
  diningSpecialMeals = [];
  showDiningSpecialMeals = false;
  defaultFrequencyIds = [0,1,2,3,4,5,6];
  selectedMealAddOns:any;
  nonDiningVenuesList: any[] = [];
  searchText = '';

  @ViewChild('LessonsDetailsDialog')  LessonsDetailsDialog;
  constructor(public activityService: GuestService,
    public route: ActivatedRoute,
    public ts: TranslateService,
    public ps: PopupService,
    public dialog: MatDialog,
    public reservationService: ReservationService,
    private activitiesDataDic: ActivitiesDataDic,
    public activityFilter : ActivityListFilterPipe,
    private dfs: DynamicFormService,public toastr: ToastrService) {
    // this.activityService?.ConfigSettings?.restaurantMerchantCode;
    this.subscriptions.add(this.activityService.allClassActivitiesAvailable$.subscribe(value => {
      this.availableActivities = value;
      this.addActivityTimeLeft();
      console.log(this.availableActivities);
      this.redirectToSlotSelection();
    }));
    // this.activityService.languageChange.subscribe(value => {
    //   if(value)
    //   this.getRestaurantWidgetSettings();
    // });
  }

  ngOnInit(): void {
    this.activityService.resetConfigBasedStyles();
    this.activityService.stopTimer();
    this.activityService.hideBackNav();
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
    this.activityService.activityIdFromURL = this.route.snapshot.params.activityId;
    this.activityService.propertyIdFromURL = +this.route.snapshot.queryParams.propertyId;
    this.activityService.sessionFilterValue = null;
    this.activityService.editData = {};
    this.activityService.operation = operationType.create;
    this.activityService.successBookRes = {};
    this.activityService.fromConfirmation = false;
    this.activityService.currentNavURL = 'list';
    this.activityService.hideCart.next(false);
    this.activityService.selectedDiningSpecialMeal = null;
    this.activityService.setSessionData('activityEditData_' + this.activityService.restaurantMerchantCode, {}, true);
    this.activityService.widgetConfigurations.subscribe(config => { this.widgetConfigurations = config; });
    this.dialog.closeAll();
    this.getRestaurantWidgetSettings();
  }

  toggleActivitiesVenue(event) {
    this.filterByVenue = false; // set this to false whenever tab change to display the venue list 1st
    this.displayByType = event.value;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }

  setWidgetConfigurations(data) {
    this.activityService.setWidgetSettings(data);
    this.toggleView = (this.widgetConfigurations.ActivityViewType < ActivityViewType.Both)
      ? this.widgetConfigurations.ActivityViewType : ActivityViewType.List;
  }
  getRestaurantWidgetSettings() {
    if (this.activityService?.restaurantMerchantCode) {
      this.activityService.startLoader();
      this.activityService.byPassValidation = true;
      this.subscriptions
        .add(this.activityService.getWidgetSettingsByMerchantCode(this.activityService.restaurantMerchantCode , false , this.activityService.selectedLanguageId)
          .subscribe((data: any) => {
            this.activityService.byPassValidation = false;
            this.activityService.stopLoader();
            if (data?.Payload) {
              this.setWidgetConfigurations(data.Payload);
              this.setActivitiesData(data.Payload.PropertyWidgetSettings);
              this.dfs.ValidateGuestPhoneNumber = data.Payload.PropertyWidgetSettings[0]?.ValidateGuestPhoneNumber;
              this.activityService.widgetSettings = data?.Payload;
              this.activityService.enableActivities = this.activityService.widgetSettings?.EnableActivities;
              this.activityService.enableDining = this.activityService.widgetSettings?.EnableDining;
              if (this.activityService.enableActivities && this.activityService.enableDining) {
                this.loadActivitiesOnly = this.activityService.isNonDining = (this.activityService.operation === operationType.edit ? !this.activityService.isDining : true);
                if(this.activityService.operation !== operationType.edit) this.activityService.isDining = false;
              } else if (!this.activityService.enableDining) {
                this.loadActivitiesOnly = this.activityService.isNonDining = true;
                this.activityService.isDining = false;
              } else {
                this.loadActivitiesOnly = this.activityService.isNonDining = false;
                this.activityService.isDining = true;
              }
              this.activityService.getWidgetImagesMerchantLevel();
              this.noDataFound = false;
              const CartList = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
              this.activityService.cartCount = CartList ? CartList.length : 0;
              const crypto = window.crypto;
              const array = new Uint32Array(1);
              this.activityService.CartBookingList$.next(crypto.getRandomValues(array));
              this.activityService.bookingSection$.next(BookingActivity.ClassBooking);
              this.loadClassActivities(data?.Payload);
              if (data?.Payload.AcceptsReservations && !data?.Payload.DisableReservations) {
                this.activityService.addGoogleTagManager(data?.Payload.WidgetCustomization.GTMCode);
              }
              this.isDataLoaded = true;
              if (this.activityService?.fromConfirmation && this.activityService?.editData?.RestaurantId) {
                if (!this.activityService.editData.isDining && !this.activityService.editData?.isOpenBooking) {
                  this.availableActivities?.forEach((val: any) => {
                    if (val?.restaurantWidgetId === this.activityService?.editData?.RestaurantId &&
                      val?.Id === this.activityService?.editData?.SpecialMealId) {
                      this.clickBookNow(val);
                    }
                  });
                } else if(this.activityService.isDining) {
                  this.filterDining();
                  this.clickReserveNow(this.diningVenuesList.find(venue => venue.RestaurantId === this.activityService?.editData?.RestaurantId));
                } else if(this.activityService.isNonDining) {
                  this.filterNonDining();
                  this.clickReserveNow_NonDining(this.nonDiningVenuesList.find(venue => venue.RestaurantId === this.activityService?.editData?.RestaurantId));
                }
              }
            }
            else {
              this.noDataFound = true;
              let validationError = '';
              if (data.ValidationMessages && data.ValidationMessages.
                filter(msg => msg.Type === ValidationMessageType.Error).length > 0) {
                data?.ValidationMessages.filter(msg => msg.Type === ValidationMessageType.Error).forEach(msg => {
                  validationError += msg.Message + '\n';
                });
                this.outOfServiceMessage = validationError;
                this.activityService.
                  openSnackBar(validationError, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
              } else {
                this.activityService.
                  openSnackBar(this.activityService.ConfigSettings.commonErrorMessage, this.ts.instant('close'),
                    this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
                this.outOfServiceMessage = this.activityService.ConfigSettings.commonErrorMessage;
              }
            }
          }, () => {
            this.noDataFound = true;
            this.activityService.openSnackBar(this.activityService.ConfigSettings.commonErrorMessage, this.ts.instant('close'),
              this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
            this.outOfServiceMessage = this.activityService.ConfigSettings.commonErrorMessage;
            this.activityService.stopLoader();
          }
          ));
    }
    else {
      this.noDataFound = true;
      this.outOfServiceMessage = this.activityService.ConfigSettings.commonErrorMessage;
      this.activityService.openSnackBar(this.activityService.ConfigSettings.commonErrorMessage, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
    }
  }

  setActivitiesData(propertyList){
    this.activitiesDataDic.setProperty(propertyList);
  }

  redirectToSlotSelection() {
    if (this.activityService.activityIdFromURL && this.route.snapshot.params.activityId) {
      if ((this.availableActivities && this.availableActivities.length > 0)
      || (this.diningSpecialMeals && this.diningSpecialMeals.length > 0)) {
        var specificActivity = this.availableActivities.filter(a => a.Id == this.activityService.activityIdFromURL);
        if (specificActivity && specificActivity.length > 0) {
          this.clickBookNow(specificActivity[0]);
        }
        else {
          var specificEvent = this.diningSpecialMeals.filter(a => a.Id == this.activityService.activityIdFromURL);
          if (specificEvent && specificEvent.length > 0) {
            var diningVenue = this.originalVenueList.filter(o => o.RestaurantId == specificEvent[0].RestaurantId);
            if (diningVenue && diningVenue.length > 0)
              this.clickReserveNow(diningVenue[0],
                specificEvent[0].Id);
          }
        }
      }
    } else if(this.activityService.propertyIdFromURL){
      let property = this.originalVenueList.find(({RestaurantId}) => RestaurantId === this.activityService.propertyIdFromURL);
      if(Utilities.controlValidate(ControlSettings.DiningProperties, property.PropertyType)){
        this.displayByType = 'dining';
        this.clickReserveNow(property);
      }else{

        this.clickReserveNow_NonDining(property);
      }
    }
  }

  loadClassActivities(data) {
    let ActivitiesList = [];
    /* this.activityService.LocationList = data.Locations;
       this.activityService.InstructorList = data.Instructors;
       this.activityService.AllocationTypes = data.AllocationMappings; */
    this.venueList = data?.PropertyWidgetSettings || [];
    this.originalVenueList = data?.PropertyWidgetSettings || [];
    data?.PropertyWidgetSettings?.forEach((eachVenue) => {
      if (eachVenue.AcceptsReservations) {
        eachVenue.venueImageUrl = environment.BaseUrl + urlConfig.widgetImageURL + eachVenue.RestaurantId;
        //dev
        // eachVenue.DefaultWaiverForm = {"Applied": true,
        //   "FormCode": "Wave1",
        //   "RestaurantId": 230};
        eachVenue?.AvailableSpecialMeals?.forEach((lesson) => {
          if(!lesson.IsForStandbyReservations)
          ActivitiesList.push(this.processEachActivities(eachVenue, lesson));
        });
      //this.activityService.addOnList = this.activityService.addOnList.concat(eachVenue?.Addons);
      }
    });
    this.dayLightDelta = data?.PropertyWidgetSettings[0].DaylightDelta;
    const currentTime =
      Utilities.getRestaurantDateTime(this.dayLightDelta);
    this.currentDateTime = new Date(currentTime.valueOf());
    this.activityService.currentDateTime = this.currentDateTime;
    this.dateFilterStartDate = this.activityService.dateFilterStartDate || new Date(this.currentDateTime.setHours(0, 0, 0, 0));
    this.activityService.dateFilterStartDate = this.dateFilterStartDate;
    this.dateFilterEndDate = this.activityService.dateFilterEndDate || new Date(this.currentDateTime.setHours(0, 0, 0, 0));
    this.activityService.dateFilterEndDate = this.dateFilterEndDate;
    this.diningSpecialMeals = _.sortBy(ActivitiesList?.filter(x => x.LessonType === LessonTypes.SpecialMeal), "SortOrder");
    let availableMeals =  this.activityFilter.transform(this.diningSpecialMeals , {startDate : this.dateFilterStartDate , endDate : this.dateFilterEndDate})
    this.showDiningSpecialMeals  = availableMeals?.length > 0 ? true : false;
    ActivitiesList = _.sortBy(ActivitiesList?.filter(x => x.isViewable && x.LessonType === LessonTypes.GroupLesson), "SortOrder");
    this.tempAvailableActivities = ActivitiesList;
    if (this.activityService.isDining) {
      this.filterDining();
    } else if(this.activityService.isNonDining){
      this.filterNonDining(true);
    }
    this.activityService.allClassActivitiesAvailable$.next(ActivitiesList);
    this.activityService.bookingSection$.next(BookingActivity.ClassBooking);
  }

  filterDining() {
    this.displayByType = 'dining';
    this.diningVenuesList = this.originalVenueList?.filter(x => 
      Utilities.controlValidate(ControlSettings.DiningProperties, x.PropertyType) && x.AcceptsReservations);
  }

  bookSpecialMeal(specialMeal) {
    this.clickReserveNow(this.diningVenuesList.find(dining => dining.RestaurantId === specialMeal.RestaurantId), specialMeal.Id);
  }

  updateDateFilterValue() {
    this.activityService.dateFilterStartDate = this.dateFilterStartDate || this.currentDateTime;
    this.activityService.dateFilterEndDate = this.dateFilterEndDate || this.activityService.dateFilterStartDate;
  }

  processEachActivities(eachVenue, lesson) {
    const activity = {};
    let locationval = [];
    const staffval = [];
    lesson?.ActivitySessions?.forEach(session => {
      session?.SessionLocationMappings?.forEach(location => {
        if ((locationval && locationval.length === 0) || locationval.length > 0
          && !locationval.find(x => x.LocationId === location.StandaloneTableId)) {
          locationval.push({ LocationName: this.getLocation(eachVenue.Locations, location), LocationId: location.StandaloneTableId });
        }
      });
      session?.SessionStaffMappings?.forEach(staff => {
        if ((staffval && staffval.length === 0) || staffval.length > 0 && !staffval.find(x => x.ServerId === staff.ServerId)) {
          staffval.push({ ServerId: staff.ServerId, StaffName: this.getInstructor(eachVenue.Instructors, staff) });
        }
      });
    });
    if (Utilities.controlValidate(ControlSettings.VenueBasedActivitiesProperties, eachVenue.PropertyType)) {
      lesson.ActivityDayOfWeeks = lesson.FrequencyTypeIds ? lesson.FrequencyTypeIds : this.defaultFrequencyIds;
    } else {
      lesson.ActivityDayOfWeeks = lesson?.ActivitySessions?.map(item => item.Dayofweek).filter((value, index, self) => self.indexOf(value) === index);
    }

    // For venue level need these settings to gathere data in diffecrent screens from the activity selected
    lesson.venueLevelLocation = eachVenue.Locations;
    lesson.venueLevelInstructors = eachVenue.Instructors;
    lesson.venueLevelAllocationMappings = eachVenue.AllocationMappings;
    lesson.restaurantWidgetId = eachVenue.RestaurantId;
    lesson.IsCartEnabled = eachVenue.IsCartEnabled;
    lesson.MaxPastTimeForReservationsInMinutes = eachVenue.MaxPastTimeForReservationsInMinutes;
    lesson.DaylightDelta = eachVenue.DaylightDelta;
    lesson.EnableMultiSlotSelection = eachVenue.EnableMultiSlotSelection;
    lesson.AllocationTypes = eachVenue.AllocationMappings;
    lesson.venueName = eachVenue.RestaurantName;
    lesson.IsSmsReminderSupported = eachVenue.IsSmsReminderSupported;
    lesson.CustomTermsOfService = eachVenue.WidgetCustomization.CustomTermsOfService;
    lesson.IsReservationReminderMandatory = eachVenue.WidgetCustomization.IsReservationReminderMandatory;
    lesson.ConfirmationVia = eachVenue.WidgetCustomization.ConfirmationVia;
    lesson.RestaurantUniqueName = eachVenue.RestaurantUniqueName;
    lesson.AllowLocationSelectionForActivity = eachVenue.WidgetCustomization.AllowLocationSelectionForActivity;
    lesson.AllowInstructorSelectionForActivity = eachVenue.WidgetCustomization.AllowInstructorSelectionForActivity;
    lesson.AllowAdditionalGuestDetails = eachVenue.WidgetCustomization.AllowAdditionalGuestDetails;
    lesson.NotesType = eachVenue.WidgetCustomization.NotesType;
    // dev
    // lesson.WaiverFormCode = "Wave1";
    lesson.DefaultWaiverForm = eachVenue.DefaultWaiverForm;

    lesson.OperationCurrency = eachVenue.OperationCurrency;
    lesson.ImageUrl = lesson.ImageURL;
    locationval = locationval?.sort((a, b) => (a.LocationName > b.LocationName) ? 1 : ((b.LocationName > a.LocationName) ? -1 : 0));
    lesson.LocationName = locationval?.map((elem) => {
      return elem.LocationName;
    }).join(',');
    eachVenue.LocationName = lesson.LocationName;
    lesson.Staffs = staffval?.filter(x => x).map((elem) => {
      return elem.StaffName;
    }).join(',');
    lesson.LessonName = lesson.Name;
    lesson.LocationId = locationval;
    lesson.StaffValues = staffval;
    lesson.SpecialMealId = lesson.Id;
    // Not considering available slots count
    lesson.Availability = lesson.ClassType === ClassType.Class && !(lesson.AvailableSlots > 0) ? this.ts.instant('notAvailable') : this.ts.instant('available');
    lesson.isViewable = locationval.length && staffval.length || false;
    lesson.PreferencesCategories = eachVenue.PreferencesCategories;
    lesson.PropertyType = eachVenue.PropertyType;
    return lesson;
  }

  filterActivitiesByVenue(eachVenue) {
    this.filterByVenue = true;
    const AllLessons = eachVenue.AvailableSpecialMeals;
    this.selectedVenueName = eachVenue.RestaurantName;
    this.venueBasedActivityList = [];
    AllLessons?.forEach(lesson => {
      if(!lesson.IsForStandbyReservations)
      this.venueBasedActivityList.push(this.processEachActivities(eachVenue, lesson));
    });
    this.venueBasedActivityList = this.loadActivitiesOnly ?
      this.venueBasedActivityList?.filter(x => x.isViewable && x.LessonType === LessonTypes.GroupLesson)
      : this.venueBasedActivityList?.filter(x => Utilities.controlValidate(ControlSettings.VenueBasedActivitiesProperties, x.PropertyType));
  }

  getLocation(locationList, location) {
    const loc = locationList?.filter(data => data.Id === location.StandaloneTableId);
    return (loc && loc.length > 0) ? loc[0].Name : '';
  }

  getInstructor(instructorList, staffdata) {
    const staff = instructorList?.filter(data => data.Id === staffdata.ServerId)[0];
    if (staff) {
      return staff.Name + ' ' + (staff.LastName || '');
    }
    else {
      return '';
    }
  }

  getActivitiesDetails(activities) {
    const dialogConfig = new MatDialogConfig();
    this.selectedActivities = activities;
    dialogConfig.data = activities;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '500px';
    dialogConfig.height = 'auto';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.panelClass = 'activitesDetailDialog';
    dialogConfig.backdropClass = 'dgBackdrop';
    this.setOtherValues();
    this.dialog.open(this.LessonsDetailsDialog, dialogConfig);
  }

  setOtherValues() {
    this.selectedActivities.activityType = this.selectedActivities.ClassType === ClassType.Session ?
      'Session' : this.selectedActivities.ClassType === ClassType.Class ? 'Class' : 'Duration';
    this.showAvailableSlotCount = this.selectedActivities.LessonType === LessonTypes.GroupLesson;
  }

  backClick($event) {
  }

  clickBookNow(data ) {
    this.dialog.closeAll();
    console.log(data);
    this.activityService.selectedActivities = data;
    this.activityService.isDining = false;
    this.activityService.isNonDining = false;
    this.activityService.LocationList = data.venueLevelLocation;
    this.activityService.InstructorList = data.venueLevelInstructors;
    this.activityService.AllocationTypes = data.venueLevelAllocationMappings;
    this.activityService.restaurantWidgetId = data.restaurantWidgetId;
    this.activityService.showGuestFields = false;
    this.activityService.navigateToUrl('slot-selection/' + data.restaurantWidgetId, {activityId: data.Id});
  }

  clickReserveNow(data, specialMealId = null) {
    const filteredStartDate = new Date(this.dateFilterStartDate).setHours(0, 0, 0, 0);
    const userCurrentDate = new Date(new Date(this.currentDateTime).setDate(new Date(this.currentDateTime).getDate() + data?.DaysForReservation - 1)).setHours(0, 0, 0, 0);
    if (data?.DaysForReservation && this.activityService.operation === operationType.create && filteredStartDate > userCurrentDate) {
      if (new Date(this.currentDateTime).setHours(0, 0, 0, 0) === userCurrentDate) {
        this.activityService.
          openSnackBar(this.ts.instant('bookingsOpenOnlyFor') + moment(this.currentDateTime).format('D MMM, YYYY'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      } else {
        this.activityService.
          openSnackBar(this.ts.instant('bookingsOpenOnlyFor') + moment(this.currentDateTime).format('D MMM, YYYY') + ' - ' + moment(userCurrentDate).format('D MMM, YYYY'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      }
      return;
    }
    this.activityService.selectedDining = data;
    this.activityService.isDining = true;
    this.activityService.isNonDining = false;
    this.activityService.restaurantWidgetId = data.RestaurantId;
    this.activityService.displaySeatingArea = data.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByArea).length > 0;
    this.activityService.displaySeatingType = data.WidgetCustomization?.LocationFilters?.filter(x => x == LocationFilter.ByType).length > 0;
    this.activityService.isSpecialMeal = false;
    this.activityService.isTableReservation = true;
    this.activityService.showGuestFields = false;
    this.activityService.DisableCustomTermsAndConditions = data.DisableCustomTermsAndConditions;
    this.activityService.ContactMinLength = data.ContactMinLength || 2;
    if (specialMealId) {
      this.activityService.selectedDiningSpecialMeal = data?.AvailableSpecialMeals.find(specialMeal => specialMeal.Id === specialMealId);
      this.activityService.isSpecialMeal = true;
      this.activityService.isTableReservation = !this.activityService.isSpecialMeal;
    }
    else if(this.activityService?.editData?.SpecialMealId){
      specialMealId = this.activityService?.editData?.SpecialMealId;
    }
    this.activityService.navigateToUrl('slot-selection/' + data.RestaurantId, {specialMealId});
  }

  clickReserveNow_NonDining(data) {
    this.activityService.clickReserveNow_NonDining(data);
    this.activityService.showGuestFields = false;
    this.activityService.DisableCustomTermsAndConditions = data.DisableCustomTermsAndConditions;
    this.activityService.ContactMinLength = data.ContactMinLength;
    this.activityService.navigateToUrl('slot-selection/' + data.RestaurantId, {bookaspot: true});
  }

  errorImageHandler(event) {
    const image = new Image();
    image.onload = () => {
      event.target.src = image.src;
    };
    image.onerror = () => {
      event.target.src = './assets/images/defaultImage.png';
    };
  }

  detailDialogClose() {
    this.dialog.closeAll();
  }

  addActivityTimeLeft() {
    if (this.availableActivities) {
      this.availableActivities.forEach(activity => {
        activity.TimeRemaining = this.getNextSessionTime(activity.ActivitySessions, activity.DaylightDelta);
        activity.Ongoing = activity.TimeRemaining?.trim() == 'Currently Running';
      });
    }
  }

  findTimeLeft(avlLessons) {
    const currentTime =
      Utilities.getRestaurantDateTime(avlLessons.DaylightDelta);
    const currentDateTime = moment(currentTime);
    const currentDate = moment(currentDateTime.format(moment.HTML5_FMT.DATE));
    let dayofWeek = currentDate.day();
    let activityStartDate = moment(avlLessons.StartDate);
    let activityEndDate = moment(avlLessons.EndDate);
    let activityDayofWeek;
    let activityEndDays;
    let nextSession = 0;
    let nextEndSession = 0;
    if (currentDate >= activityStartDate && currentDate <= activityEndDate) {
      let dateDifference: number = activityEndDate.diff(currentDateTime, 'days');
      for (let i = 0; i <= dateDifference; i++) {
        let currDate = moment(currentDateTime);
        currDate.add('days', i);
        activityDayofWeek = avlLessons.ActivitySessions.filter(session => {
          let localDate = moment(currDate.format(moment.HTML5_FMT.DATE) + ' ' + session.StartTime);
          let dayOfWeek = localDate.day();
          return dayOfWeek === session.Dayofweek && localDate >= currentDateTime
        });
        if (activityDayofWeek.length > 0) {
          nextSession = Math.min(...activityDayofWeek.map(x => moment(currDate.format(moment.HTML5_FMT.DATE) + ' ' + x.StartTime)));
          break;
        }
        activityEndDays = avlLessons.ActivitySessions.filter(session => {
          let localDate = moment(currDate.format(moment.HTML5_FMT.DATE) + ' ' + session.EndTime);
          return dayofWeek === session.Dayofweek && localDate >= currentDateTime
        });
        if (activityEndDays.length > 0 && dateDifference == 0) {
          nextEndSession = Math.min(...activityEndDays.map(x => moment(currDate.format(moment.HTML5_FMT.DATE) + ' ' + x.StartTime)));
          break;
        }
      }
      return nextSession ? this.activityService.allocateTimeUnits(moment(nextSession), currentDateTime) : (nextEndSession ? 'Currently Running' : null);
    }
    return '-';
  }

  filterNonDining(initialLoad?: boolean){
    this.displayByType ='non_dining';
    this.nonDiningVenuesList = this.originalVenueList?.filter(x => Utilities.controlValidate(ControlSettings.OpenBookingProperties, x.PropertyType)
      && x.AcceptsReservations && x.WidgetCustomization.ActivityBookings.filter(y => y == ActivityBookings.OpenBooking)?.length);

      if(initialLoad && !this.nonDiningVenuesList?.length && this.tempAvailableActivities.length
        || (initialLoad && this.activityService.operation === operationType.edit 
            && (this.activityService.editData && !this.activityService.editData?.isOpenBooking && !this.activityService.editData?.isDining))) {
        this.displayByType ='activities';
      }
  }

  
  getNextSessionTime(sessions, DaylightDelta) {
    const currentTimeData = Utilities.getRestaurantDateTime(DaylightDelta);
    const currentTime = moment(currentTimeData); // Use moment to handle the time

    let nextSessionStart = null;

    // Loop through all the sessions
    sessions.forEach(session => {
        // Loop through each session's date range
        session.SessionDateRanges.forEach(dateRange => {
            const sessionDate = moment(dateRange.StartDate);
            // Set session start time by combining date and start time
            const sessionStartTime = sessionDate.set({
                hour: session.StartTime.split(":")[0],
                minute: session.StartTime.split(":")[1],
                second: session.StartTime.split(":")[2],
                millisecond: 0
            });

            // If session start time is in the future and is the earliest, update nextSessionStart
            if (sessionStartTime.isAfter(currentTime) && (nextSessionStart === null || sessionStartTime.isBefore(nextSessionStart))) {
                nextSessionStart = sessionStartTime;
            }
        });
    });

    if (nextSessionStart) {
        return  this.activityService.allocateTimeUnits(moment(nextSessionStart), currentTime);
    } else {
        return "No upcoming sessions.";
    }
  }

}


@Pipe({
  name: 'checkAcceptReservations'
})
export class checkAcceptReservationsPipe implements PipeTransform {

  transform(data: any): any {
    return (data.filter(prop => prop.AcceptsReservations).length)
  }


}
